<template>
  <div>
    <!-- ================= GIFTS ================= -->
    <section ref="raiz" class="lluvia-sobres">
      <div class="contenido">
        <h2 ref="tituloRef" class="titulo">
          <span class="serif"><br />Gifts</span><br /><br />
        </h2>

        <p ref="textoRef" class="texto">
          Your presence is the most valuable gift to me. ✨  
          But if you would like to give me a detail, I will receive it with much love. 
          <br> "The envelope shower is the tradition of giving cash on the day of the event"
        </p><br /><br />

        <h2 ref="tituloRef" class="titulo">
          <span class="serif">Envelope</span><br />
          <span class="script">Shower</span>
        </h2>

        <!-- 🔹 ENVELOPE -->
        <img ref="sobreRef" :src="sobrePng" class="icono-sobre" alt="Envelope" />

        <!-- 🔹 ENVELOPE TEXT -->
        <p ref="lluviaTextoRef" class="lluvia-texto"></p>

        <!-- 🔹 THANK YOU -->
        <h2 ref="tituloRef" class="titulo">
          <span class="serif">Cash </span><br />
          <span class="script">App</span>
        </h2>

        <!-- 🔥 CASH APP -->
        <div ref="cashRef" class="cash-container">
          <img src="@/assets/cash.png" class="cash-img" alt="Cash App QR" />

          <a 
            href="https://cash.app/$CaroR09" 
            target="_blank" 
            class="cash-link"
          >
            https://cash.app/$CaroR09
          </a><br /><br />
        </div>

        <p ref="graciasRef" class="gracias">THANK YOU!</p>

      </div>

      <div ref="lluviaIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaDer" class="lluvia lluvia-der"></div>
    </section>

    <!-- ================= CHILDREN ================= -->
    <section ref="raizNinos" class="lluvia-sobres">
      <div class="contenido">
        <h2 ref="tituloNinosRef" class="titulo">
          <span class="serif">Yes children!</span>
        </h2>

        <p ref="textoNinosRef" class="texto">
          In order to maintain a pleasant and safe environment, we kindly ask that children remain under the supervision of their parents at all times.
        </p>

        <p ref="graciasNinosRef" class="gracias"></p>
      </div>

      <div ref="lluviaNinosIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaNinosDer" class="lluvia lluvia-der"></div>
    </section>
  </div>
</template>
<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {

    const raiz = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const lluviaTextoRef = ref(null)
    const graciasRef = ref(null)
    const cashRef = ref(null)

    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    const raizNinos = ref(null)
    const tituloNinosRef = ref(null)
    const textoNinosRef = ref(null)
    const graciasNinosRef = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)

    let stInstance = null
    let stInstanceNinos = null

    const crearLluvia = (contenedorEl, lado = 'der', cantidad = 10) => {
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.className = 'sobre-lluvia'
        contenedorEl.appendChild(el)

        gsap.fromTo(el,
          { xPercent: lado === 'der' ? 110 : -10, yPercent: 0, opacity: 0 },
          {
            xPercent: lado === 'der' ? -20 : 120,
            yPercent: 140,
            opacity: 1,
            duration: 2,
            ease: 'power2.out',
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      stInstance = ScrollTrigger.create({
        trigger: raiz.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {

          const titulos = raiz.value.querySelectorAll('.titulo')

          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          // 🔥 PRIMER TÍTULO (Lluvia)
          tl.from(titulos[0], { opacity: 0, y: 30, duration: 0.6 })

            .from(textoRef.value, { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')
            .from(sobreRef.value, { opacity: 0, scale: 0.7, duration: 0.6 }, '-=0.3')
            .from(lluviaTextoRef.value, { opacity: 0, y: 20 }, '-=0.3')

            // 🔥 SEGUNDO TÍTULO (Cash App)
            .from(titulos[1], { opacity: 0, y: 30, duration: 0.6 })

            // 🔥 CASH APP
            .from(cashRef.value, {
              opacity: 0,
              y: 40,
              scale: 0.9,
              duration: 0.7,
              ease: "back.out(1.7)"
            })

            // 🔥 GRACIAS AL FINAL
            .from(graciasRef.value, { opacity: 0, y: 20, duration: 0.4 })

          crearLluvia(lluviaDer.value)
          crearLluvia(lluviaIzq.value)
        }
      })

      stInstanceNinos = ScrollTrigger.create({
        trigger: raizNinos.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          gsap.timeline()
            .from(tituloNinosRef.value, { opacity: 0, y: 30 })
            .from(textoNinosRef.value, { opacity: 0, y: 20 }, '-=0.3')
        }
      })
    })

    onUnmounted(() => {
      if (stInstance) stInstance.kill()
      if (stInstanceNinos) stInstanceNinos.kill()
    })

    return {
      raiz,
      tituloRef,
      textoRef,
      sobreRef,
      lluviaTextoRef,
      graciasRef,
      cashRef,
      lluviaIzq,
      lluviaDer,
      raizNinos,
      tituloNinosRef,
      textoNinosRef,
      graciasNinosRef,
      lluviaNinosIzq,
      lluviaNinosDer,
      sobrePng
    }
  }
}
</script>
<style scoped>
.cash-container{
  margin-top: 20px;
  text-align: center;
}

.cash-img{
  width: 140px;
  margin: 10px auto;
  display: block;
}

.cash-link{
  display: block;
  color: white;
  font-size: 22px !important;
  margin-top: 8px;
  text-decoration: underline;
}
</style>


<style scoped>
.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background: #f0c9d3;
  overflow: hidden;
}
.contenido{ position: relative; z-index: 2; }

.titulo{
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}
.titulo .serif{
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}
.titulo .script{
  font-family: 'nombre', cursive;
  font-size: 44px;
  font-weight: 400;
  display: inline-block;
  opacity: .95;
}

.texto{
  font-family: 'quote', serif;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  max-width: 420px;
  margin: 12px auto 18px;
  opacity: .95;
}

.icono-sobre{
  width: 110px;
  height: auto;
  display: block;
  margin: 8px auto 8px;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,.12));
}

.gracias{
  font-family: 'padres', serif;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: .08em;
  font-weight: 800;
  margin: 4px 0 0;
}

.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}
.lluvia-izq{ left: 0; }
.lluvia-der{ right: 0; }

.sobre-lluvia{
  position: absolute;
  top: -10%;
  left: 0;
  width: 28px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.10));
}

@media (max-width: 380px){
  .titulo .serif{ font-size: 50px; }
  .titulo .script{ font-size: 40px; }
  .icono-sobre{ width: 96px; }
}
.lluvia-texto{
  font-family: 'padres', serif;
  font-size: 18px;
  color: #ffffff;
  margin-top: 8px;
  letter-spacing: .05em;
  opacity: .95;
}
</style>
